module.exports = __webpack_public_path__ + "media/images/icons/sw-math-8ecdf6526f7df9877750395228c4d93a.svg";